// This file is auto-generated. Run `pnpm generate:icons` to regenerate.
// biome-ignore-all assist/source/organizeImports: Generated file.
// biome-ignore-all format: Generated file.
import type { IconComponent, IconName } from "./icon-types";
import AddPlusIcon from "./generated/add-plus";
import ArrowLeftIcon from "./generated/arrow-left";
import ArrowUpRightIcon from "./generated/arrow-up-right";
import BarsFilterRegularIcon from "./generated/bars-filter-regular";
import ButtonLoadSpinnerIcon from "./generated/button-load-spinner";
import CalendarIcon from "./generated/calendar";
import CheckMarkIcon from "./generated/check-mark";
import ChevronDownIcon from "./generated/chevron-down";
import ChevronLeftIcon from "./generated/chevron-left";
import ChevronRightIcon from "./generated/chevron-right";
import ChevronUpIcon from "./generated/chevron-up";
import CircleCheckRegularIcon from "./generated/circle-check-regular";
import CircleCheckIcon from "./generated/circle-check";
import CircleExclamationIcon from "./generated/circle-exclamation";
import CircleInfoIcon from "./generated/circle-info";
import CopyRegularIcon from "./generated/copy-regular";
import DownloadIcon from "./generated/download";
import EllipsisDotsHorizIcon from "./generated/ellipsis-dots-horiz";
import EllipsisDotsIcon from "./generated/ellipsis-dots";
import ErrorSolidIcon from "./generated/error-solid";
import ErrorIcon from "./generated/error";
import EyeWatchingIcon from "./generated/eye-watching";
import FilterIcon from "./generated/filter";
import MenuHamburgerIcon from "./generated/menu-hamburger";
import NotificationBellIcon from "./generated/notification-bell";
import OilAnalysisBottleIcon from "./generated/oil-analysis-bottle";
import PlusRegularIcon from "./generated/plus-regular";
import PriorityIcon from "./generated/priority";
import SearchIcon from "./generated/search";
import SettingsCogIcon from "./generated/settings-cog";
import SortIcon from "./generated/sort";
import SparklesIcon from "./generated/sparkles";
import UploadIcon from "./generated/upload";
import WarningIcon from "./generated/warning";
import XCloseIcon from "./generated/x-close";

export const coreIconRegistry = {
  "add-plus": AddPlusIcon,
  "arrow-left": ArrowLeftIcon,
  "arrow-up-right": ArrowUpRightIcon,
  "bars-filter-regular": BarsFilterRegularIcon,
  "button-load-spinner": ButtonLoadSpinnerIcon,
  "calendar": CalendarIcon,
  "check-mark": CheckMarkIcon,
  "chevron-down": ChevronDownIcon,
  "chevron-left": ChevronLeftIcon,
  "chevron-right": ChevronRightIcon,
  "chevron-up": ChevronUpIcon,
  "circle-check-regular": CircleCheckRegularIcon,
  "circle-check": CircleCheckIcon,
  "circle-exclamation": CircleExclamationIcon,
  "circle-info": CircleInfoIcon,
  "copy-regular": CopyRegularIcon,
  "download": DownloadIcon,
  "ellipsis-dots-horiz": EllipsisDotsHorizIcon,
  "ellipsis-dots": EllipsisDotsIcon,
  "error-solid": ErrorSolidIcon,
  "error": ErrorIcon,
  "eye-watching": EyeWatchingIcon,
  "filter": FilterIcon,
  "menu-hamburger": MenuHamburgerIcon,
  "notification-bell": NotificationBellIcon,
  "oil-analysis-bottle": OilAnalysisBottleIcon,
  "plus-regular": PlusRegularIcon,
  "priority": PriorityIcon,
  "search": SearchIcon,
  "settings-cog": SettingsCogIcon,
  "sort": SortIcon,
  "sparkles": SparklesIcon,
  "upload": UploadIcon,
  "warning": WarningIcon,
  "x-close": XCloseIcon,
} satisfies Partial<Record<IconName, IconComponent>>;